import { motion } from "framer-motion";
import { Leaf } from "./Decor";

const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", y = 36, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, inView = false }) {
  const anim = { y: "0%" };
  const transition = (i) => ({ duration: 1.1, delay: delay + i * 0.15, ease: EASE });
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          {inView ? (
            <motion.span
              className={`block ${lineClassName}`}
              initial={{ y: "112%" }}
              whileInView={anim}
              viewport={{ once: true, margin: "-60px" }}
              transition={transition(i)}
            >
              {line}
            </motion.span>
          ) : (
            <motion.span
              className={`block ${lineClassName}`}
              initial={{ y: "112%" }}
              animate={anim}
              transition={transition(i)}
            >
              {line}
            </motion.span>
          )}
        </span>
      ))}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, dark = false, center = false, testId }) {
  return (
    <div className={`${center ? "text-center mx-auto" : "text-left"} max-w-2xl`} data-testid={testId}>
      {eyebrow && (
        <FadeUp>
          <span
            className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] font-semibold ${
              dark ? "text-goldlight" : "text-gold"
            }`}
          >
            <Leaf className="w-3.5 h-3.5" />
            {eyebrow}
          </span>
        </FadeUp>
      )}
      <FadeUp delay={0.08}>
        <h2
          className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold leading-[1.08] text-balance ${
            dark ? "text-cream" : "text-forest"
          }`}
        >
          {title}
        </h2>
      </FadeUp>
      {subtitle && (
        <FadeUp delay={0.16}>
          <p className={`mt-4 text-base font-light leading-relaxed ${dark ? "text-cream/70" : "text-muted"}`}>
            {subtitle}
          </p>
        </FadeUp>
      )}
    </div>
  );
}
